import { JetView } from 'webix-jet';

/**
 * Class representing the view for eliminating note withdrawals.
 * @extends JetView
 */
export default class EliminateNoteWithdrawView extends JetView {
    /**
     * Configures the layout of the view.
     * @returns {Object} The configuration object for the view.
     */
    config() {
        const _ = this.app.getService('locale')._; // Localization service
        const screen = this.app.config.size; // Screen size configuration

        // Left section containing text fields
        const left = {
            margin: 5,
            rows: [
                {
                    view: 'text',
                    name: 'fecha_crea', // Creation date field
                    label: _('Fecha de creación:'),
                    labelPosition: 'top',
                    disabled: true, // Field is disabled
                },
                {
                    view: 'text',
                    name: 'nombre_usuario', // User name field
                    label: _('Nombre de Usuario:'),
                    labelPosition: 'top',
                    disabled: true, // Field is disabled
                },
                {
                    view: 'text',
                    name: 'valor', // Note value field
                    label: _('Valor de la nota:'),
                    labelPosition: 'top',
                    disabled: true, // Field is disabled
                },
            ],
        };

        // Center left section (currently empty)
        const center_left = {
            margin: 5,
            rows: [],
        };

        // Center right section (currently empty)
        const center_right = {
            margin: 5,
            rows: [],
        };

        // Right section (currently empty)
        const right = {
            margin: 5,
            rows: [],
        };

        // Upper section layout combining left, center, and right sections
        const upper_section = {
            cols: [
                left,
                { gravity: 0, minWidth: 10 },
                center_left,
                { gravity: 0, minWidth: 10 },
                center_right,
                { gravity: 0, minWidth: 10 },
                right,
            ],
        };

        // Button section with an action to eliminate a note
        const buttons = {
            margin: 10,
            cols: [
                {},
                {
                    view: 'button',
                    value: _('Eliminar'), // Button label
                    type: 'form',
                    autowidth: true,
                    click: () => {
                        if (this.getRoot().validate()) {
                            // Validate form before action
                            webix.message(_('Eliminar Nota')); // Show message on button click
                        }
                    },
                },
            ],
        };

        // Return the complete form configuration
        return {
            view: 'form',
            id: 'formEliminateNoteWithdraw', // Form ID
            rows: [upper_section, buttons], // Form layout
        };
    }

    /**
     * Initializes the view and sets up event listeners.
     * @param {Object} form - The form instance.
     */
    init(form) {
        $$('formEliminateNoteWithdraw').hide(); // Hide the form initially
        this.on(this.app, 'eliminateNoteWithdraw:data', (noteWithdraw) => {
            form.setValues(noteWithdraw); // Set form values with noteWithdraw data
            console.log('recarga', noteWithdraw); // Log the noteWithdraw data
        });
    }
}

// FILE DOCUMENTED
